import { removeUser } from "../../../store/slices/userSlice";
import {
  setActiveWidget,
  setDataWidgets,
  setNewWidget,
  setUpdateWidget,
} from "../../../store/slices/widgetSlice";
import { errorToast } from "../../methods/toast";
import { $authHost, $hostTest } from "../http";

export const getWidgetToken = (dataWidget, navigate) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.post("/user/widget", dataWidget);
      dispatch(getWidgetList(dataWidget.userId));
      dispatch(setNewWidget(null));
      if (data.code === 200) {
        dispatch(setActiveWidget(data.widget));
        navigate(`/integration/widget/active/${data.widget.id}`);
        localStorage.setItem("activeWidget", JSON.stringify(data.widget));
      } else {
        errorToast("Произошла ошибка при получении токена виджета");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 403) {
          errorToast("Доступ запрещен");
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("getWidgetToken error:", error);
    }
  };
};

export const getWidgetList = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await $hostTest.get(`/user/widget/list?userId=${id}`);
      if (data.code === 200) {
        dispatch(setDataWidgets(data.widgets));
        localStorage.setItem("dataWidgets", JSON.stringify(data.widgets));
      } else {
        errorToast(
          "Ошибка получения виджетов: " + data.message || "Неизвестная ошибка"
        );
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast("Ошибка получения данных. Пожалуйста, попробуйте позже.");
      }
      console.error("Error in getWidgetList:", error);
    }
  };
};

export const updateWidgetDomains = (widgetData, setLoading) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $hostTest.put(`/user/widget`, widgetData);
      if (data.code === 200) {
        setLoading(false);
        dispatch(setUpdateWidget(null));
        dispatch(setNewWidget(null));
        dispatch(setActiveWidget(data.widget));
        localStorage.setItem("activeWidget", JSON.stringify(data.widget));
      } else {
        setLoading(false);
        errorToast(
          "Ошибка обновления виджета: " + data.message || "Неизвестная ошибка"
        );
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast("Ошибка обновления данных. Пожалуйста, попробуйте позже.");
      }
      console.error("Error in updateWidgetDomains:", error);
    }
  };
};

export const updateWidgetStatus = (statusData) => {
  return async (dispatch) => {
    try {
      const { data } = await $hostTest.put(`/user/widget/status`, statusData);
      if (data.code === 200) {
        dispatch(setActiveWidget(data.widget));
        localStorage.setItem("activeWidget", JSON.stringify(data.widget));
      } else {
        errorToast(
          "Ошибка обновления статуса виджета: " + data.message ||
            "Неизвестная ошибка"
        );
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере");
        }
      } else {
        errorToast("Ошибка обновления статуса. Пожалуйста, попробуйте позже.");
      }
      console.error("Error in updateWidgetStatus:", error);
    }
  };
};
